import { OrgsApi, Org } from '@/api';

export class OrgsModule {
	private api: OrgsApi;
	constructor() {
		this.api = new OrgsApi();
	}
	public async get(orgId: number): Promise<Org | undefined> {
		return;
	}

	public async getRegionalCouncil(): Promise<Org[]> {
		const res = await this.api.orgGetRegionalCouncils();
		if (res != undefined && res.data != undefined && res.data.data != undefined) {
			return res.data.data;
		}
		return [];
	}

	public async getFtpTargets(): Promise<Org[]> {
		const res = await this.api.orgGetFtpTargets();
		if (res != undefined && res.data != undefined && res.data.data != undefined) {
			return res.data.data;
		}
		return [];
	}
}
